import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import axios, { AxiosError } from "axios"; // Axios-Import hinzufügen
import { API_BASE_URL } from "@/config"; // API_BASE_URL importieren
import LoginView from "@/views/LoginView.vue";
import DashboardView from "@/views/DashboardView.vue";
import RegisterView from "@/views/RegisterView.vue";
import AdminView from "@/views/AdminView.vue";
import ManagementView from "@/views/ManagementView.vue";
import InstandsetzungView from "@/views/InstandsetzungView.vue";
import RetourenView from "@/views/RetourenView.vue";
import RetourenSortingView from "@/views/RetourenSortingView.vue";
import RetourenSortingV2View from "@/views/RetourenSortingV2View.vue";
import RefurbishView from "@/views/RefurbishView.vue";
import DtcView from "@/views/DtcView.vue";
import OfficeView from "@/views/OfficeView.vue";
import VersandView from "@/views/VersandView.vue";
import ArtikelKatalogUploadView from "@/views/ArtikelKatalogUploadView.vue";
import StatistikView from "@/views/StatistikView.vue";
import UserControlPanelView from "@/views/UserControlPanelView.vue";
import CalendarView from "@/views/CalendarView.vue";
import NebentaetigkeitenView from "@/views/NebentaetigkeitenView.vue";
import SummaryView from "@/views/SummaryView.vue";
import UploadView from "@/views/UploadView.vue";
import DatenschutzerklaerungView from "@/views/DatenschutzerklaerungView.vue";
import ImpressumView from "@/views/ImpressumView.vue";
import ChangelogsView from "@/views/ChangelogsView.vue";
import CommissionView from "@/views/CommissionView.vue";
import RequestView from "@/views/RequestView.vue";
import EmptyView from '@/views/EmptyView.vue';
import DevToolsView from '@/views/DevToolsView.vue';
import ChatView from '@/views/ChatView.vue';
import StatusView from '@/views/StatusView.vue';
import ServiceStatusView from '@/views/ServiceStatusView.vue';
import ReinigungsplanView from '@/views/ReinigungsplanView.vue';
import QRGeneratorView from '@/views/QRGeneratorView.vue';
import IrisCodeMatrixView from '@/views/IrisCodeMatrixView.vue';
import SubscriptionView from '@/views/SubscriptionView.vue';
import MessageCenterView from '@/views/MessageCenterView.vue';
import KvConfirmationView from '@/views/KvConfirmationView.vue';
import WoIstOliView from '@/views/WoIstOliView.vue';
import InventurView from '@/views/InventurView.vue';
import InventurOfficeView from '@/views/InventurOfficeView.vue';
import BWareView from '@/views/BWareView.vue';
import BWareLeistungView from '@/views/BWareLeistungView.vue';
import ListsOverview from '@/components/DynamicLists/ListsOverview.vue';
import ListDetail from '@/components/DynamicLists/ListDetail.vue';

const routes = [
  { path: "/", component: LoginView },
  { path: "/register", component: RegisterView, meta: { requiresAuth: true } },
  { path: "/dashboard", component: DashboardView, meta: { requiresAuth: true } },
  { path: "/admin", component: AdminView, meta: { requiresAuth: true, requiresAdmin: true } },
  { path: "/management", component: ManagementView, meta: { requiresAuth: true, requiresSuper_Admin: true } },
  { path: "/instandsetzung", component: InstandsetzungView, meta: { requiresAuth: true } },
  { path: "/retouren", component: RetourenView, meta: { requiresAuth: true } },
  { path: "/retouren-sorting", component: RetourenSortingView, meta: { requiresAuth: true } },
  { path: "/retouren-sorting-v2", component: RetourenSortingV2View, meta: { requiresAuth: true } },
  { path: "/refurbish", component: RefurbishView, meta: { requiresAuth: true } },
  { path: "/dtc", component: DtcView, meta: { requiresAuth: true } },
  { path: "/office", component: OfficeView, meta: { requiresAuth: true } },
  { path: "/versand", component: VersandView, meta: { requiresAuth: true } },
  { path: "/artikel-katalog-upload", component: ArtikelKatalogUploadView, meta: { requiresAuth: true } },
  { path: "/statistik", component: StatistikView, meta: { requiresAuth: true } },
  { path: "/user-control-panel", component: UserControlPanelView, meta: { requiresAuth: true } },
  { path: "/calendar", component: CalendarView, meta: { requiresAuth: true } },
  { path: "/nebentaetigkeiten", component: NebentaetigkeitenView, meta: { requiresAuth: true } },
  { path: "/summary", component: SummaryView, meta: { requiresAuth: true } },
  { path: "/upload", component: UploadView, meta: { requiresAuth: true } },
  { path: "/privacypolicy", component: DatenschutzerklaerungView, meta: { requiresAuth: true } },
  { path: "/impressum", component: ImpressumView, meta: { requiresAuth: true } },
  { path: "/changelogs", component: ChangelogsView, meta: { requiresAuth: true } },
  { path: "/commission", component: CommissionView, meta: { requiresAuth: true } },
  { path: "/request", component: RequestView, meta: { requiresAuth: true } },
  { path: "/empty", component: EmptyView, meta: { requiresAuth: true } },
  { path: '/reset-password', name: 'ResetPassword', component: () => import('../views/ResetPasswordView.vue'), meta: { requiresAuth: false } },
  { path: "/devtools", component: DevToolsView, meta: { requiresAuth: true, requiresDeveloper: true } },
  { path: "/chat", component: ChatView, meta: { requiresAuth: true } },
  { path: "/status", component: StatusView, meta: { requiresAuth: true } },
  { path: "/service-status", component: ServiceStatusView, meta: { requiresAuth: true } },
  { path: "/reinigungsplan", component: ReinigungsplanView, meta: { requiresAuth: true } },
  { path: "/qr-generator", component: QRGeneratorView, meta: { requiresAuth: true } },
  { path: '/ersatzteile', name: 'Ersatzteile', component: () => import('@/views/SparePartsView.vue'), meta: { requiresAuth: true } },
  { path: '/iris-code-matrix', name: 'IrisCodeMatrix', component: IrisCodeMatrixView, meta: { requiresAuth: true } },
  { path: "/subscription", component: SubscriptionView, meta: { requiresAuth: true } },
  { path: "/messages", component: MessageCenterView, meta: { requiresAuth: true } },
  { path: "/kv-confirmations", component: KvConfirmationView, meta: { requiresAuth: true } },
  { path: "/wo-ist-oli", component: WoIstOliView, meta: { requiresAuth: true } },
  { path: "/inventur", component: InventurView, meta: { requiresAuth: true, requiresInventur: true } },
  { path: "/inventur/auswertung", component: InventurOfficeView, meta: { requiresAuth: true, requiresInventurOffice: true } },
  { path: "/b-ware", component: BWareView, meta: { requiresAuth: true } },
  { path: "/b-ware-leistung", component: BWareLeistungView, meta: { requiresAuth: true } },
  { path: "/lists", name: 'DynamicLists', component: ListsOverview, meta: { requiresAuth: true } },
  { path: "/lists/:id", name: 'ListDetail', component: ListDetail, meta: { requiresAuth: true } },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// ✅ ROUTER GUARD: Prüft, ob der User eingeloggt ist
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();

  // 🚀 Authentifizierung sollte bereits in main.ts wiederhergestellt worden sein
  // aber für Sicherheit prüfen wir, ob sie noch läuft
  if (!authStore.isAuthenticated && localStorage.getItem("userData")) {
    // Falls Auth noch nicht wiederhergestellt wurde, kurz warten
    await new Promise(resolve => setTimeout(resolve, 100));
  }

  // Bei jeder Navigation: Ist der Benutzer wirklich eingeloggt?
  if (to.meta.requiresAuth && authStore.isAuthenticated) {
    try {
      // Schnelle Session-Prüfung bei jeder Navigation zu geschützten Routen
      const response = await axios.post(
        `${API_BASE_URL}auth_check.php`,
        { action: "check" },
        {
          withCredentials: true,
          timeout: 5000 // 5 Sekunden Timeout
        }
      );

      // Session ist gültig, aktualisiere Benutzerdaten falls nötig
      if (response.data.user) {
        // Optional: Benutzerdaten aktualisieren
        authStore.user = response.data.user;
      }

      // Prüfen, ob der Nutzer nur Lagerist ist (und keine anderen Rollen hat)
      const isLageristOnly = authStore.user?.lagerist &&
        !authStore.user?.admin &&
        !authStore.user?.super_admin &&
        !authStore.user?.developer &&
        !authStore.user?.monteur &&
        !authStore.user?.returen_sorting &&
        !authStore.user?.inventur &&
        !authStore.user?.office;

      // Lagerist-only darf auf /commission, /kv-confirmations, /request und /versand zugreifen
      const lageristAllowedPaths = ['/commission', '/kv-confirmations', '/request', '/versand'];
      if (isLageristOnly && !lageristAllowedPaths.includes(to.path)) {
        next('/empty');
        return;
      }

      // Inventur-Rolle: Scanner-Zugriff
      if (to.meta.requiresInventur &&
          !authStore.user?.inventur &&
          !authStore.user?.lagerist &&
          !authStore.user?.admin &&
          !authStore.user?.super_admin &&
          !authStore.user?.developer) {
        next('/empty');
        return;
      }

      // Inventur-Auswertung: nur Office + Admin-Stufen
      if (to.meta.requiresInventurOffice &&
          !authStore.user?.office &&
          !authStore.user?.admin &&
          !authStore.user?.super_admin &&
          !authStore.user?.developer) {
        next('/empty');
        return;
      }

      // KORRIGIERT: Wenn Lagerist-Rechte für die Route erforderlich sind, aber der Benutzer
      // weder Lagerist noch Admin, Super-Admin oder Developer ist
      if (to.meta.requiresLagerist &&
          !authStore.user?.lagerist &&
          !authStore.user?.admin &&
          !authStore.user?.super_admin &&
          !authStore.user?.developer) {
        next('/empty');
        return;
      }

      // NEUE PRÜFUNG: Developer-Berechtigung
  if (to.meta.requiresDeveloper && !authStore.user?.developer) {
    console.warn("⚠️ Keine Developer-Berechtigung");
    return next("/dashboard");
  }

      // Berechtigungsprüfungen für verschiedene Routen
      if (to.meta.requiresAdmin && (!authStore.user?.admin && !authStore.user?.super_admin && !authStore.user?.developer)) {
        // Weiterleitung zur EmptyView, wenn Admin-Rechte fehlen
        next("/empty");
      } else if (to.meta.requiresSuper_Admin && !authStore.user?.super_admin) {
        // Weiterleitung zur EmptyView, wenn Super-Admin-Rechte fehlen
        next("/empty");
      } else {
        // Ausreichende Rechte vorhanden, Navigation fortsetzen
        next();
      }
    } catch (error: unknown) {
      // Session ist ungültig, zurücksetzen und zur Login-Seite
      if (axios.isAxiosError(error)) {
        if (error.response && error.response.status === 401) {
          // 401: Nicht authentifiziert - Session zurücksetzen
          console.warn("⚠️ Session ungültig (401), logout");
          if (typeof authStore.resetSession === 'function') {
            authStore.resetSession();
          } else {
            authStore.logout();
          }
          next("/");
          return;
        } else if (error.code === 'ECONNABORTED' || !error.response) {
          // Timeout oder Netzwerkfehler - trotzdem durchlassen
          console.warn("⚠️ Netzwerkfehler bei auth_check, lasse Navigation zu");
          next();
          return;
        }
      }
      // Bei anderen Fehlern trotzdem durchlassen
      console.error("Fehler bei auth_check:", error);
      next();
    }
  } else if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next("/");
  } else {
    next();
  }
});

export default router;
